import {useUserStore} from "~/store/user.store";
import {useGlobalStore} from "~/store/global.store";

export default defineNuxtPlugin(async (nuxtApp) => {
    const globalStore = useGlobalStore()
    const userStore = useUserStore()
    
    // Сначала загружаем глобальные настройки
    await globalStore.fetchSettings()
    
    // Затем обрабатываем логику города из route параметров
    if (globalStore.locations.cities.length > 0) {
        const cityCookie = useCookie('city', {
            path: '/',
            secure: true,
            sameSite: 'none',
        });

        const route = useRoute()
        if(!cityCookie.value && route.params.city) {
            cityCookie.value = globalStore.locations.cities.find(item => item.name.toLowerCase().replace(/ /g, '-') === route.params.city)?.documentId || null
            userStore.city = cityCookie.value || null;
        }
    }
    
    // Инициализируем userStore
    userStore.init()
}) 